import { formatDamageTypes } from '../../../shared/rules/effects/saveDamagePresentation.mjs';
const memoryHandled = new Set();

const abilityAbbreviations = {
  strength: 'STR',
  dexterity: 'DEX',
  constitution: 'CON',
  intelligence: 'INT',
  wisdom: 'WIS',
  charisma: 'CHA',
};

const notificationKey = (resolution) =>
  `saveDamageResult:${resolution.resolutionId}:${resolution.targetCombatantId}`;


/**
 * Presents a finalized save-damage result using only the server's persisted
 * resolution. Returning false means that no player-facing result was emitted.
 */
export const notifyTargetSaveDamage = ({
  resolution,
  controlledCombatantId,
  notify,
  storage = typeof window !== 'undefined' ? window.sessionStorage : null,
}) => {
  const response = resolution?.targetSave?.response;
  const ability = String(resolution?.targetSave?.ability || '').toLowerCase();
  const finalDamage = resolution?.damageOutcome?.finalDamage;
  const components = resolution?.rules?.damage?.components;
  const damageType = formatDamageTypes(components);
  if (resolution?.status !== 'finalized'
    || resolution?.targetSave?.status !== 'resolved'
    || !resolution?.resolutionId
    || !resolution?.targetCombatantId
    || String(controlledCombatantId || '') !== String(resolution.targetCombatantId)
    || typeof response?.succeeded !== 'boolean'
    || !abilityAbbreviations[ability]
    || !Number.isFinite(finalDamage)
    || !Array.isArray(components) || !components.length
    || components.some((component) => typeof component.type !== 'string' || !component.type.trim())
    || typeof damageType !== 'string'
    || !damageType.trim()) return false;

  const key = notificationKey(resolution);
  if (memoryHandled.has(key) || storage?.getItem(key) === '1') return false;

  const outcome = response.succeeded ? 'Successful' : 'Failed';
  notify(
    `${abilityAbbreviations[ability]} Save ${outcome}\n${finalDamage} ${damageType} damage taken`,
    response.succeeded ? 'success' : 'danger'
  );
  memoryHandled.add(key);
  try { storage?.setItem(key, '1'); } catch (error) { /* Memory deduplication remains available. */ }
  return true;
};

export const resetTargetSaveDamageNotificationsForTest = () => memoryHandled.clear();

